<template>
  <div>
    

    <list
      row-key="UserId"
      ref="list"
      unit="设备排产"
      :page="false"
      show-checkbox
      :show-toolbar="false"
      :is-table="false"
      :show-query="true"
      :get-data-func="api.list" 
      customQuary
      @customQuary="customQuary"
      @resetQuery="resetQuery"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="选择设备">
          <el-select v-model="ProductionDpId" @change="changeProductionDpId" clearable @clear="clearProductionDpId">
            <el-option v-for="(item) in tempDpList" :key="item.ProductionDpId" :value="item.ProductionDpId" :label="item.ProductionDpName + '(' + item.ProductionDpNumber + ')'"></el-option>
          </el-select>
          <!-- <tree-select @node-select="nodeSelect" :options="teamOption" :props="props"></tree-select> -->
        </el-form-item>
      </template>
      <template slot="tabs">
        <el-tabs type="card" @tab-click="tabClick">
          <el-tab-pane label="未排产工单">
            <not-scheduling  ref="notScheduling" @listEnd="notlistEnd" @getDp="getDp" :dpid="notProductionDpId"></not-scheduling>
          </el-tab-pane>
          <el-tab-pane label="已排产工单">
            <already-scheduling  ref="alreadyScheduling" :dpid="alreadyProductionDpId"  @listEnd="alreadylistEnd" @end="end"  @getDp="getDp1"></already-scheduling>
          </el-tab-pane>
        </el-tabs>
      </template>
    </list>
    <cloth-dialog ref="clothDialog" @select="select" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import treeSelect from '../treeSelect'

import notScheduling from "./notScheduling";
import alreadyScheduling from "./alreadyScheduling";

import clothDialog from './clothDialog'

export default {
  mixins: [curdMixins, listMixin],
  components: { list, notScheduling, alreadyScheduling, treeSelect, clothDialog },
  data() {
    return {
      props: {
        value: "DpId", 
        label: "DpName", 
        children: "children", 
      },
      isShow: false,
      api: require("@/api/pu/plan").default,
      dpApi: require("@/api/ent/dp").default,
      teamOption: [],
      params: {
        team: "",
      },
      dpid: null,
      tableData: [
       
      ],
      isTableShow: true,
      tempDpList: [],
      dpList: [],
      dpList1: [],
      ProductionDpId: null,
      notProductionDpId: null,
      alreadyProductionDpId: null,
      tabName: "0",
      alreadySchedulingData: [],
      OrderProductIds: [],
    };
  },
  mounted(){
    this.dpApi.list({}).then(res => {
      let teamOption = this.$commonJs.toTreeData(res.Data, 'DpId');
      this.teamOption = this.getTeamOption(teamOption)
    })
  },

  methods: {
    end(){ // 已排产操作结束时返回的事件
      console.log('触发')
      this.$refs.notScheduling.subTableEnter();
    },
    getDp(data){
      this.dpList = data;
      if(this.tabName === '0'){
        this.tempDpList = this.dpList;
      }
    },
    getDp1(data){
      this.dpList1 = data;
      if(this.tabName === '1'){
        this.tempDpList = this.dpList1;
      }
    },
    customQuary(){ // 顶部自定义搜索
      this.$refs.notScheduling.subTableEnter()
    },
    resetQuery(){
      this.ProductionDpId = null
      this.clearProductionDpId();
    },
    notlistEnd({OrderProductIds}){ // 未排产列表已更新显示
      this.OrderProductIds = OrderProductIds;
      this.$refs.alreadyScheduling.subTableEnter()
    },
    alreadylistEnd(data){
      this.$refs.notScheduling.setAleayData(data)
    },
    changeProductionDpId(val){
      console.log('val', val)
      if(this.tabName === '0'){
        this.notProductionDpId = val;
      }else{
        this.alreadyProductionDpId = val;
      }
    },
    clearProductionDpId(){
      if(this.tabName === '0'){
        this.notProductionDpId = null;
      }else{
        this.alreadyProductionDpId = null;
      }
    },
    del(row){
      let b = row.b;
      let index = this.tableData.findIndex(item => {
        return item.b === b;
      })
      this.tableData.splice(index, 1);
    },
    select(list){
      this.tableData = list;
    },
    openDialog(){
      this.$refs.clothDialog.open().then(that => {
       that.$refs.list.getData()
      })
    },
    getTeamOption(option){
      
      let length = option.length;
      for(let i = 0; i < length; ++i){
        option[i].DpName = option[i].DpName + `(${option[i].DpId})`

        if(option[i].children != undefined ){
          this.getTeamOption(option[i].children)
        }
        
      }

      return option

    },
   
    nodeSelect(node){
      this.params.team = node.DpId
      this.dpid = node.DpId;

    },
    tabClick({index}){
      this.tabName = index;
      switch(index){
        case '0':
          this.tempDpList = this.dpList;
          this.ProductionDpId = this.notProductionDpId;
           break;
        case '1':
          this.tempDpList = this.dpList1;
          this.ProductionDpId = this.alreadyProductionDpId;
          break;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.flex{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 18px;
}
</style>
